import React, {useState} from "react";
import { Box, Column, Columns, Pagination, Table, Title } from "@allxsmith/bestax-bulma";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import FilterHeading from "../Invoicing/FilterHeading";
import AccountBalanceRow from "./AccountBalanceRow";
import {useContactsData} from "../../hooks/useContactsData";
import {useSelector} from "react-redux";
import {getContactsData, getDataFresh} from "../../state/selectors";
import Spinner from "react-spinner-material";
import Nav from "../Nav/Nav";
import PaginationWrapper from "../Utils/PaginationWrapper";



export default function ContactsAccountBalance(props){
    const dataFresh = useSelector(getDataFresh)
    const [page, setPage] = useState(1);
    const [filters, setFilters] = useState({});
    const headings = [
        {
            label: "Name",
            field: "display_name",
            labelField: "display_name",
            blank: false
        },
        {
            label: "Phone Number",
            field: "company_phone",
            labelField: "company_phone",
            blank: false
        },
        {
            label: "Credit Limit",
        },
        {
            label: "Account Balance",
        },
    ];
    let params ={page:page, contact_type:'CC'}

    for (let filter in filters) {
      if (filters[filter][0] && filters[filter][0][filter]) {
        params[filter] = filters[filter][0][filter];
      }
    }

    let loaded = useContactsData(params)
    const contacts = useSelector(getContactsData)

    if(!loaded){
        return(
            <div>
                <Nav/>
                <Box>
                    <Spinner
                      className="spinner-centre"
                      size={120}
                      spinnerColor={"#3273dc"}
                      spinnerWidth={2}
                    />
                </Box>
            </div>
        );
    }


    // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
    return (
        <div>
            <Nav/>
            <Box>
                <Title>Customer Account Balance</Title>
                <Columns isMultiline>
                    <Column>
                        <Table className={"is-hoverable"} isFullwidth>
                            <thead>
                                <tr>
                                  {headings.map(heading => {
                                    if (!heading.field) {
                                      return <th key={heading.label}>{heading.label}</th>;
                                    }
                                    if (heading.blank) {
                                      return (
                                        <FilterBlankHeading
                                          key={heading.label}
                                          heading={heading}
                                          setFilters={f => {
                                            setPage(1);
                                            setFilters(f);
                                          }}
                                          filters={filters}
                                        />
                                      );
                                    }
                                    return (
                                      <FilterHeading
                                        key={heading.label}
                                        heading={heading}
                                        setFilters={f => {
                                          setPage(1);
                                          setFilters(f);
                                        }}
                                        filters={filters}
                                        options={contacts.filter_list[heading.field]}
                                      />
                                    );
                                  })}
                                </tr>
                            </thead>
                            <tbody>
                                {contacts.results.map((contact, index) => (
                                    <AccountBalanceRow
                                        contact={contact}
                                        index={index}
                                    />
                                ))
                                }
                            </tbody>
                        </Table>
                    </Column>
                </Columns>
                <PaginationWrapper
                    setPage={setPage}
                    page={page}
                    dataCount={Math.ceil(contacts.count / 25)}
                />
            </Box>
        </div>
    );

}